import { searchForBlogs } from './storefront-graphql-helper.js'
const currentUrl = window.location.href;
const urlParts = currentUrl.split('?');
let searchTerm
const searchResultDiv = document.getElementById('blog-search-results')
const searchResultTotalDiv = document.getElementById('blog-search-total')
const loadMoreButton = document.querySelector('#bs-loadmore')


// Handle no results 
const setNoResults = () => {
  searchResultDiv.innerHTML = `<p>Sorry, there are no results for this search please try another search query.</p>`
}
// truncation
const returnSearchExcerpt = (input) => {
  const maxLength = window.innerWidth > 750 ? 372 : 27
    if (input.length <= maxLength) {
      return input
    } else {
      return input.slice(0, maxLength) + '...';
    }
}

// handling pagination functionality 
const loadPagination = () => {
  loadMoreButton.addEventListener('click', async () => {
    const paginationString = loadMoreButton.dataset.nextPage
    const response = await searchForBlogs(searchTerm, paginationString)
    buildSearchResults(response, true)
  })
}


const buildSearchResults = (results, paginate) => {
  const searchResults = results.search.edges
  if (searchResults.length) {
    // build our results - either adding onto existing or creating new
    let searchResultHTML = ''
    searchResults.forEach(result => {
      const html = `
      <div class="bs-result">
        <div class="bs-image">
          <img src="${result.node.image?.url}" alt="${result.node.image?.alt}">
        </div>
        <div class="bs-info-container">
          <h2>${result.node.title}</h2>
          <p>${returnSearchExcerpt(result.node.excerpt)}</p>
          <a href="${result.node.handle}">Read more</a>
        </div>
      </div>
      `
      searchResultHTML += html
    })
    if (paginate) {
      searchResultDiv.innerHTML += searchResultHTML
    } else {
      searchResultDiv.innerHTML = searchResultHTML
    }

    searchResultTotalDiv.innerHTML = `Showing <strong>${document.querySelectorAll('.bs-result').length}</strong> results for "${searchTerm}"` 
    
    // Creating our loadmore button 
    if (results.search.pageInfo.hasNextPage) {
      loadMoreButton.style.display = "block"
      // Add our gql string for pagination 
      loadMoreButton.dataset.nextPage = results.search.pageInfo.endCursor
      loadPagination()
    } else {
      loadMoreButton.style.display = "none"
    }
  } else {
    setNoResults()
  }
}

// Because boost automatically targets name="q" on search inputs we have to use 'search' 
// and there is a bit of a weird path /blogs/all/article-search?z={query}
if (urlParts.length > 1) {
  const queryParams = urlParts[1];
  const paramPairs = queryParams.split('&');
  const params = {};
  paramPairs.forEach(function (paramPair) {
    const keyValue = paramPair.split('=');
    params[keyValue[0]] = keyValue[1];
  });
  searchTerm = params['search'];
  const response = await searchForBlogs(searchTerm)
  buildSearchResults(response)
} else {
  setNoResults()
}

// Need to just disable the blog types here. because these add url params and mess up this JS for the search page.
// Will be best to redirect them to the blog homepage and they start their journey again. 
const blogTypeLinks = document.querySelectorAll('.blog__menu--item ')
blogTypeLinks?.forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault()
    window.location.href = '/blogs/all'
  })
})